import { render, staticRenderFns } from "./tabSelect.vue?vue&type=template&id=4d80a421&scoped=true&"
import script from "./tabSelect.vue?vue&type=script&lang=js&"
export * from "./tabSelect.vue?vue&type=script&lang=js&"
import style0 from "./tabSelect.vue?vue&type=style&index=0&id=4d80a421&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80a421",
  null
  
)

export default component.exports